<template>
    <button
            aria-haspopup="true"
            :aria-expanded="nav_visible"
            id="meta-hamburger"
            :class="cssClass"
            aria-label="Main Menu"
            @click="clicked">
        <IconMenu class="icon-menu" v-show="!nav_visible" :aria-hidden="nav_visible" />
        <IconClose class="icon-close" v-show="nav_visible" :aria-hidden="!nav_visible" />
        <span class="label" v-show="nav_visible" :aria-hidden="!nav_visible">Close Menu</span>
    </button>
</template>


<script>
import { mapGetters } from 'vuex'

import IconClose from '@/assets/svg/icon-close-x.svg'
import IconMenu from '@/assets/svg/icon-menu.svg'

export default {
    name: 'Nav',
    components: {
        IconClose,
        IconMenu
    },
    data(){
        return{
            testOpen: false
        }
    },
    computed: {
        ...mapGetters({
            'nav_visible': 'global/nav_visible',
            'visible': 'global/hamburger_visible',
        }),
        cssClass() {
            return this.visible ? 'visible' : 'hidden'
        },
    },
    methods: {
        clicked: function() {
            this.$store.dispatch("global/toggleNav")
        }
    }
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

$hamburger-size: 50px;

#meta-hamburger {
    position: fixed;
    background-color: #FFFFFF33;
    border: none;
    border-radius: $hamburger-size;
    cursor: pointer;
    height: $hamburger-size;
    opacity: 1;
    right: $s3;
    top: $s3;
    transition: $transition-default;
    width: $hamburger-size;
    z-index: 9991;

    &:hover {
        background-color: $color-green;
    }

    &.hidden {
        opacity: 0;
        visibility: hidden;
    }

    .icon-close {
        display: block;
        transform: scale(.8);
        margin: 13px 8px;
    }
    .icon-menu {
        display: block;
        margin: 11px 2px;
        transform: scale(.7);
    }
    .label {
        display: none;
    }
}
</style>
